import { render } from "./list-reports.view.vue?vue&type=template&id=2523a2eb&scoped=true&ts=true"
import script from "./list-reports.view.vue?vue&type=script&lang=ts"
export * from "./list-reports.view.vue?vue&type=script&lang=ts"

import "./list-reports.view.vue?vue&type=style&index=0&id=2523a2eb&lang=scss&scoped=true"
import "./list-reports.view.vue?vue&type=style&index=1&id=2523a2eb&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2523a2eb"]])

export default __exports__